import React from "react";
import { useNavigate } from "react-router-dom";
import { X, ArrowLeft } from "lucide-react";

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4 -mt-24">
      <div className="w-full max-w-2xl bg-[#FEE2E2] rounded-xl p-8 md:p-16 relative flex flex-col items-center text-center">
        
        {/* Back Arrow */}
        <button 
          onClick={() => navigate(-1)}
          className="absolute top-6 left-6 text-gray-700 hover:scale-110 transition-transform"
        >
          <ArrowLeft size={24} />
        </button>

        {/* Failed Icon */}
        <div className="w-16 h-16 bg-[#FF0000] rounded-full flex items-center justify-center mb-6 shadow-lg shadow-red-200">
          <X className="text-white" size={36} strokeWidth={3} />
        </div>

        {/* Text Content */}
        <h1 className="text-2xl md:text-3xl font-bold text-[#7F1D1D] mb-4">
          Payment Failed
        </h1>
        <p className="text-[#B91C1C] font-medium mb-10 max-w-sm">
          Network error, try after sometimes
        </p>

        {/* Button */}
        <button
          onClick={() => navigate("/cart-page")}
          className="bg-[#FF0000] hover:bg-red-700 text-white px-12 py-3 rounded-md font-semibold transition-colors shadow-md"
        >
          Back to Cart
        </button>
      </div>
    </div>
  );
};

export default CancelPage;